export enum EUserRole {
  ADMIN = 'ADMIN',
}

export type TTUserWallet = {
  address: string;
  createdAt: string;
  id: string;
  isDefault: boolean;
  updatedAt: string;
};

export interface IUser {
  id: string;
  email: string;
  points: number;
  wallets: TTUserWallet[];
  role: EUserRole;
}
